import { render, staticRenderFns } from "./displayWrapper.vue?vue&type=template&id=20a971f2&scoped=true"
import script from "./displayWrapper.vue?vue&type=script&lang=js"
export * from "./displayWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a971f2",
  null
  
)

export default component.exports